var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { List } from "../generic/list/List";
import { RewardPelletItem } from "./RewardPelletItem";
export var RewardPelletGroup = React.memo(function (_a) {
    var items = _a.items;
    var renderRewardPelletItem = function (rewardPelletItem, index) {
        return React.createElement(RewardPelletItem, __assign({}, rewardPelletItem, { key: index }));
    };
    return React.createElement(List, { items: items, renderItem: renderRewardPelletItem });
});



//////////////////
// WEBPACK FOOTER
// ./src/features/reward-pellets/RewardPelletGroup.tsx
// module id = 2322
// module chunks = 3